import React, { useEffect } from "react";
import FloatingLogoAndButton from "../FloatingLogoAndButton/FloatingLogoAndButton";
import { Helmet } from "react-helmet-async";
import heroImg from "../../assets/images/bydgoszcz/cigar/cigar-whisky-whitebull.jpg";
import imgHistory from "../../assets/images/bydgoszcz/cigar/the-new-york.jpg";
import imgColumbus from "../../assets/images/bydgoszcz/cigar/the-new-york-public.jpg";
import imgFactory from "../../assets/images/bydgoszcz/cigar/richard-sagredo-rollling-hands.jpg";
import imgGentleman from "../../assets/images/bydgoszcz/cigar/yohan-cho-cigar.jpg";
import imgModern from "../../assets/images/bydgoszcz/cigar/considerate-agency-unsplash.jpg";
import imgCTA from "../../assets/images/bydgoszcz/cigar/anthony-torres-cigar-whisky.jpg";

export default function HistoriaCygar() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            headline: "Historia cygar – od rytuałów do luksusu",
            description:
              "Poznaj historię cygar – od rdzennych kultur Ameryki po współczesną kulturę palarni cygar.",
            author: {
              "@type": "Organization",
              name: "Whitebull Steakhouse",
            },
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": "https://whitebull.com.pl/historia-cygar",
            },
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "Skąd pochodzą cygara?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Cygara pochodzą z Ameryki Środkowej i Południowej, gdzie były używane przez Majów i Azteków.",
                },
              },
              {
                "@type": "Question",
                name: "Kiedy cygara trafiły do Europy?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Cygara trafiły do Europy po odkryciu Ameryki przez Krzysztofa Kolumba w 1492 roku.",
                },
              },
            ],
          })}
        </script>
      </Helmet>
      <div className="bg-black text-white min-h-screen flex flex-col items-center px-4 py-10">
        <FloatingLogoAndButton />
        <div className="mb-20"></div>

        {/* HERO */}
        <section className="max-w-4xl text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Historia cygar – od rytuałów do luksusu
          </h1>
          <img
            src={heroImg}
            alt="cygaro dym klimat premium"
            className="w-full max-w-4xl h-80 object-cover mb-8"
          />
          <p className="text-lg opacity-90">
            Historia cygara to podróż przez tysiące lat – od duchowych rytuałów
            rdzennych ludów Ameryki po współczesną kulturę luksusu i relaksu.
          </p>
        </section>

        {/* SEKCJA 1 */}
        <section className="max-w-3xl mb-12">
          <h2 className="text-2xl font-semibold mb-4">
            🌿 Początki cygara – kultura Nowego Świata
          </h2>
          <p className="opacity-90">
            Historia cygara sięga tysięcy lat wstecz i zaczyna się w Ameryce
            Środkowej oraz Południowej. Cywilizacje takie jak Majowie i
            Aztekowie wykorzystywały tytoń nie tylko rekreacyjnie, ale przede
            wszystkim w rytuałach religijnych.
          </p>
          <p className="opacity-90 mt-3">
            Zwinięte liście tytoniu – pierwowzór dzisiejszego cygara – były
            palone podczas ceremonii jako forma komunikacji z bóstwami oraz
            narzędzie medyczne.
          </p>
        </section>

        {/* SEKCJA 2 */}
        <section className="max-w-3xl mb-12">
          <h2 className="text-2xl font-semibold mb-4">
            🚢 Odkrycie dla Europy
          </h2>
          <p className="opacity-90">
            Przełom nastąpił w 1492 roku, kiedy Krzysztof Kolumb dotarł do
            Nowego Świata. To właśnie jego załoga jako pierwsza przywiozła
            zwyczaj palenia tytoniu do Europy.
          </p>
          <img
            src={imgHistory}
            alt="rytuał palenia tytoniu Majowie Aztekowie"
            className="w-full h-64 object-cover mt-6"
          />
          <p className="opacity-90 mt-3">
            Szczególnie znany jest Rodrigo de Jerez, który nauczył się palić
            cygaro od rdzennych mieszkańców Karaibów. Po powrocie do Hiszpanii
            jego zwyczaj został uznany za coś niepokojącego – według przekazów
            został nawet uwięziony.
          </p>
        </section>

        {/* SEKCJA 3 */}
        <section className="max-w-3xl mb-12">
          <img
            src={imgColumbus}
            alt="Kolumb odkrycie tytoniu Europa"
            className="w-full h-64 object-cover mt-6"
          />
          <h2 className="text-2xl font-semibold mb-4">
            🇪🇸 Narodziny europejskiej tradycji
          </h2>
          <p className="opacity-90">
            W XVIII wieku Sewilla stała się centrum przemysłu tytoniowego.
            Powstała tam Real Fábrica de Tabacos – jedna z pierwszych wielkich
            fabryk tytoniu w Europie.
          </p>
          <p className="opacity-90 mt-3">
            Rozwinięto techniki selekcji liści, fermentacji oraz ręcznego
            zwijania cygara. Hiszpania importowała wysokiej jakości tytoń z
            Kuby, co zapoczątkowało słynną tradycję cygar kubańskich.
          </p>
        </section>

        {/* SEKCJA 4 */}
        <section className="max-w-3xl mb-12">
          <img
            src={imgFactory}
            alt="fabryka cygar ręczne zwijanie"
            className="w-full h-64 object-cover mt-6"
          />
          <h2 className="text-2xl font-semibold mb-4">
            🌍 XIX wiek – symbol statusu
          </h2>
          <p className="opacity-90">
            W XIX wieku cygaro rozprzestrzeniło się po całej Europie i szybko
            stało się symbolem prestiżu, władzy i wyrafinowanego stylu życia.
          </p>
          <p className="opacity-90 mt-3">
            Powstawały ekskluzywne kluby, w których palenie cygara było
            elementem kultury towarzyskiej i biznesowej.
          </p>
        </section>

        {/* SEKCJA 5 */}
        <section className="max-w-3xl mb-12">
          <h2 className="text-2xl font-semibold mb-4">
            🏭 Industrializacja i rozwój
          </h2>
          <img
            src={imgGentleman}
            alt="gentleman cigar luxury"
            className="w-full h-64 object-cover mt-6"
          />
          <p className="opacity-90">
            Rewolucja przemysłowa przyniosła rozwój produkcji cygar. Mimo
            pojawienia się maszyn, ręczne zwijanie pozostało symbolem najwyższej
            jakości.
          </p>
        </section>

        {/* SEKCJA 6 */}
        <section className="max-w-3xl mb-12">
          <img
            src={imgModern}
            alt="palarnia cygar nowoczesna Whitebull"
            className="w-full h-72 object-cover mt-6"
          />
          <h2 className="text-2xl font-semibold mb-4">
            🍽️ Współczesna kultura cygara
          </h2>
          <p className="opacity-90">
            Dziś cygaro to element stylu życia – symbol relaksu, celebracji i
            wyjątkowej atmosfery. Współczesne miejsca łączą tradycję z
            nowoczesnością, tworząc przestrzeń do spokojnego spędzania czasu.
          </p>
        </section>

        {/* PODSUMOWANIE */}
        <section className="max-w-3xl text-center mb-12">
          <h2 className="text-2xl font-semibold mb-4">Podsumowanie</h2>
          <p className="opacity-90">
            Historia cygara to droga od rytuałów rdzennych ludów Ameryki, przez
            rozwój europejskiej tradycji, aż po współczesne doświadczenie
            łączące smak, aromat i atmosferę.
          </p>
          <img
            src={imgCTA}
            alt="cygaro i whisky Whitebull klimat"
            className="w-full h-72 object-cover my-4"
          />
        </section>

        {/* CTA */}
        <section className="text-center max-w-3xl">
          <a href="/palarnia-cygar-bydgoszcz" className="underline opacity-80">
            → Zobacz palarnię cygar w Whitebull
          </a>
        </section>
      </div>
    </>
  );
}
